import { Component, inject, Input } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataLayer } from '../../../models/data-layer';
import { Indicator } from '../../../models/indicator';
import { IndicatorData } from '../../../models/indicator-data';
import { HeaderComponent } from '../../atoms/header/header.component';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { DividerModule } from 'primeng/divider';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { ChipModule } from 'primeng/chip';
import { DataLayerType } from '../../../models/data-layer-type';

@Component({
  selector: 'app-confirm-publish-data',
  standalone: true,
  imports: [
    ConfirmDialogModule,
    HeaderComponent,
    AlertComponent,
    DividerModule,
    CheckboxModule,
    FormsModule,
    ScrollPanelModule,
    ChipModule,
  ],
  templateUrl: './confirm-publish-data.component.html',
  styleUrl: './confirm-publish-data.component.scss',
})
export class ConfirmPublishDataComponent {
  readonly dataStore = inject(IndicatorDataStore);
  readonly indicatorStore = inject(IndicatorStore);

  @Input() dataLayerType!: DataLayerType;
  @Input() dataLayer!: DataLayer;
  @Input() indicator!: Indicator;
  @Input() indicatorData!: IndicatorData;

  public publishDataLayerId = false;
}
